import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import axios from "axios";

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import { emyFormCreate } from '../../routes/UserAction';


import { QRCodeCanvas } from 'qrcode.react';

import { formBase, domain, timeFormat, reduceText, domainUrl } from '../../data/dummyData';

const fieldTypes = [
    "text", "email", "number", "textarea", "select",
    "radio", "checkbox", "file", "audio", "video", "image"
];
  

// export default function DataForm() {
const FormBuilder = ({ onSubmit }) => {
    const dispatch = useDispatch();

    const [fields, setFields] = useState([]);
    const [location, setLocation] = useState(null);
    const [isPublic, setIsPublic] = useState(true);
    const [name, setName] = useState(null);
    const [about, setAbout] = useState(null);

    const generateFormId = () => {
        return Math.random().toString(36).substr(2, 6).toUpperCase();
    };

    const [formId, setFormId] = useState(generateFormId());
    const [formKey, setFormKey] = useState(null);
    const [viewKey, setViewKey] = useState(null);
    const [isForm, setIsForm] = useState(false);
    const [file, setFile] = useState(null);


    useEffect(() => {
        navigator.geolocation.getCurrentPosition(
        (pos) => {
            setLocation({
            lat: pos.coords.latitude,
            long: pos.coords.longitude,
            });
        },
        (err) => console.warn('Geolocation error:', err)
        );
    }, []);


    const addField = () => {
        setFields([...fields, {
        label: "",
        type: "text",
        required: false,
        options: [],
        }]);
    };

    const handleFieldChange = (i, key, value) => {
        const updated = [...fields];
        updated[i][key] = value;
        setFields(updated);
    };

    const handleSubmit = () => {

        if (!isPublic && (!formKey?.length || !viewKey?.length)) {
            alert('For Private Form, you need both keys: Viewkey for those to answer & Responsekey for you to see the answers')
            
        } else {
            const formJSON = {
                name,
                url: formId,
                data: JSON.stringify({ fields }),
                lat: location.lat,
                long: location.long,
                about,
                image: `${formBase}/${formId}`,
                access: formKey,
                view: viewKey,
                is_public: isPublic ? 1 : 0
            };
            // onSubmit(formJSON);
    
            dispatch(emyFormCreate(formJSON))
            .then((response) => {
                // console.log('Form created successfully!', response);
                setAbout('');
                setName('');
                setFields([]);
                setFormKey('');
                setFormId(generateFormId());
            })
            .catch((error) => {
                // alert('Form creation failed:', error);
                console.error('Form creation failed:', error);
            });
        }
        
    };


    const [formUrl, setFormUrl] = useState(`${formBase}/${formId}`);

    // const [formUrl, setFormUrl] = useState(isPublic
    //     ? `${formBase}/${formId}` 
    //     : `${formBase}/${formId}?key=${formKey}`
    // );

    const removeField = (index) => {
        setFields(prevFields => prevFields.filter((_, i) => i !== index));
    };

    const renderField = (field, idx) => {
        switch (field.type) {
            case 'text':
            case 'email':
            case 'number':
                return (
                    <input
                        type={field.type}
                        className="form-control border-0"
                        id={`field-${idx}`}
                        placeholder={`Enter ${field.label}`}
                    />
                );
            case 'textarea':
                return (
                    <textarea
                        className="form-control border-0"
                        id={`field-${idx}`}
                        placeholder={`Enter ${field.label}`}
                        rows="4"
                    />
                );
            case 'select':
                return (
                    <select
                        className="form-control border-0"
                        id={`field-${idx}`}
                    >
                        <option value="">Select</option>
                        {field.options.map((opt, optIdx) => (
                            <option key={optIdx} value={opt}>{opt}</option>
                        ))}
                    </select>
                );
            case 'radio':
                return (
                    <div>
                        {field.options.map((opt, optIdx) => (
                            <div key={optIdx} className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`field-${idx}`}
                                    id={`radio-${idx}-${optIdx}`}
                                    value={opt}
                                />
                                <label className="form-check-label" htmlFor={`radio-${idx}-${optIdx}`}>
                                    {opt}
                                </label>
                            </div>
                        ))}
                    </div>
                );
            case 'checkbox':
                return (
                    <div>
                        {field.options.map((opt, optIdx) => (
                            <div key={optIdx} className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkbox-${idx}-${optIdx}`}
                                    value={opt}
                                />
                                <label className="form-check-label" htmlFor={`checkbox-${idx}-${optIdx}`}>
                                    {opt}
                                </label>
                            </div>
                        ))}
                    </div>
                );
            case 'file':
            case 'audio':
            case 'video':
            case 'image':
                return (
                    <input
                        type="file"
                        className="form-control border-0"
                        id={`field-${idx}`}
                        accept={field.type === 'image' ? 'image/*' :
                                field.type === 'audio' ? 'audio/*' :
                                field.type === 'video' ? 'video/*' : '*'}
                    />
                );
            default:
                return null;
        }
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmitFile = async (e) => {
    
        if (!file || !name) {
          alert("Form name and file are required.");
          return;
        }

        if (!isPublic && (!formKey?.length || !viewKey?.length)) {
            alert('For Private Form, you need both keys: Viewkey for those to answer & Responsekey for you to see the answers')
            
        } else {
            const data = new FormData();
            data.append("url", formId);
            data.append("lat", location.lat);
            data.append("long", location.long);
            data.append("about", about);
            data.append("name", name);
            data.append("image", `${formBase}/${formId}`);
            data.append("access", formKey);
            data.append("view", viewKey);
            data.append("is_public", isPublic ? 1 : 0);

            data.append("file", file);

            try {
                const res = await axios.post(`${domainUrl}/emy-upload-excel-data`, data, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                });
          
                alert("Upload successful!");
                console.log(res.data);

                setAbout('');
                setName('');
                setFields([]);
                setFormKey('');
                setFormId(generateFormId());

              } catch (error) {
                // console.error(error);
                alert("Upload failed.", error);
                console.error('Upload failed:', error);
            }
        }


    };
    


    return (
        // loading ? (
        //   <div className="loader-container">
        //       <div className="spinner"></div>
        //       {/* <h6 style={{color: 'white', textAlign:'center'}}>loading please wait...</h6> */}
        //   </div>
        // ) :
        <>
        <Header page={'contact'}/>

            <div className="container-fluid contact py-5">
                <div className="container py-5">
                    <div className="row g-5">

                        <div className="text-center mt-4">
                            <h3>✅ Form Initialized Successfully!</h3>
                            <p>Share this link:</p>
                            <a href={`${formBase}/${formId}`} target="_blank" rel="noopener noreferrer">{`${formBase}/${formId}`}</a>

                            <div className="mt-3 mx-auto">
                                <div
                                    className="mt-3"
                                    style={{
                                    position: 'relative',
                                    width: 128,
                                    height: 128,
                                    margin: '0 auto'
                                    }}
                                >
                                    <QRCodeCanvas
                                        value={`${formBase}/${formId}`}
                                        size={128}
                                        style={{ width: '100%', height: '100%' }}
                                        />
                                        <img
                                        src="./assets/img/emy.png"
                                        alt="Logo"
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            width: '30px',
                                            height: '40px',
                                            transform: 'translate(-50%, -50%)',
                                            borderRadius: '8px',
                                            background: 'white',
                                            padding: '2px'
                                        }}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className="col-lg-12 mb-1 text-success">
                            <input 
                                type="checkbox" 
                                className="form-check-input mx-2" 
                                id="isForm" 
                                checked={isForm}
                                onChange={(e) => setIsForm(e.target.checked)}
                            />

                            <label className="form-check-label text-primary" htmlFor="isForm">
                                {isForm ? " Create form fields" : " Upload excel"}
                            </label>
                        </div>
                        
                        {isForm? 
                        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.4s">
                            <div className="form-section bg-success p-5 h-100">
                                <h1 className="display-4 text-white mb-4">Create Form</h1>

                                <div className="row my-3">
                                    <div className="col-6">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="formname" 
                                            placeholder="Enter Title"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            />
                                            <label for="formname">Enter Title</label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="formurl" 
                                            placeholder="Enter Url"
                                            value={formId}
                                            onChange={(e) => setFormId(e.target.value)}
                                            />
                                            <label for="formurl">Enter Url</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 my-2">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="about" 
                                            placeholder="Enter About"
                                            value={about}
                                            onChange={(e) => setAbout(e.target.value)}
                                            />
                                            <label for="about">Enter About</label>
                                        </div>
                                    </div>
                                </div>
                                

                                <div>
                                    <div className="row my-3">
                                
                                        <div className="col-lg-12 mb-1">
                                            <input 
                                                type="checkbox" 
                                                className="form-check-input" 
                                                id="isPublic" 
                                                checked={isPublic}
                                                onChange={(e) => setIsPublic(e.target.checked)}
                                            />

                                            <label className="form-check-label text-white" htmlFor="isPublic">
                                                {isPublic ? " 🔓 Public Form (Anyone can access)" : " 🔒 Private Form (Requires Keys)"}
                                            </label>
                                        </div>
                                        
                                        {!isPublic? 
                                            <>
                                            <p className='text-warning'>Viewkey for those to answer & Responsekey for you to see the answers!</p>
                                            <div className="col-lg-12 col-xl-6 my-1">
                                                <div className="form-floating form-section-col">
                                                    <input 
                                                    type="text" 
                                                    className="form-control border-0" 
                                                    id="formkey" 
                                                    placeholder="Enter View Key"
                                                    value={formKey}
                                                    onChange={(e) => setFormKey(e.target.value)}
                                                    />
                                                    <label for="formkey">View Key</label>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-xl-6 my-1">
                                                <div className="form-floating form-section-col">
                                                    <input 
                                                    type="text" 
                                                    className="form-control border-0" 
                                                    id="viewKey" 
                                                    placeholder="Enter Response Key"
                                                    value={viewKey}
                                                    onChange={(e) => setViewKey(e.target.value)}
                                                    />
                                                    <label for="viewKey">Response Key</label>
                                                </div>
                                            </div>
                                            </>
                                        
                                        : null}
                                        
                                    </div>



                                    {fields.map((field, i) => (
                                        <div className="row g-4" key={i}>
                                            <div className="col-lg-12 col-xl-6">
                                                <div className="form-floating form-section-col">
                                                    <input 
                                                        type="text" 
                                                        className="form-control border-0" 
                                                        id="name" 
                                                        placeholder="Label"
                                                        value={field.label}
                                                        onChange={e => handleFieldChange(i, "label", e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-xl-6">
                                                <div className="form-floating form-section-col">
                                                    <select
                                                        className='form-control border-0'
                                                        value={field.type}
                                                        onChange={e => handleFieldChange(i, "type", e.target.value)}
                                                    >
                                                        {fieldTypes.map(ft => (
                                                            <option key={ft} value={ft}>{ft}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-xl-6">
                                                <div className="form-floating form-section-col">
                                                    {["select", "radio", "checkbox"].includes(field.type) && (
                                                        <textarea
                                                            className='form-control border-0'
                                                            placeholder="Comma separated options"
                                                            value={field.options.join(',')}
                                                            onChange={e => handleFieldChange(i, "options", e.target.value.split(','))}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                            <div className="col-4 col-xl-6">
                                                <div className="form-floating form-section-col">
                                                    <div className="form-check">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="checkbox" 
                                                            // value="#" 
                                                            id="flexCheck"
                                                            onChange={e => handleFieldChange(i, "required", e.target.checked)}
                                                        />
                                                        <label className="form-check-label text-white" for="flexCheck">Required</label>

                                                        {/* <i className='fa fa-minus mx-3 text-white'></i> */}
                                                        <i 
                                                            className='fa fa-minus mx-3 text-danger' 
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => removeField(i)}
                                                        ></i>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <hr className='text-white' />
                                        </div>
                                    ))}
                                
                                    <div className="row g-4 my-3">
                                        <div className="col-6">
                                            <div className="form-section-col">
                                                <button className="btn-primary w-100 py-3 px-5" onClick={addField}>Add Field</button>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-section-col">
                                                <button className="btn-warning w-100 py-3 px-5" onClick={handleSubmit}>Save Form</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :

                        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.4s">
                            <div className="form-section bg-success p-5 h-100">
                                <h1 className="display-4 text-white mb-4">Upload Excel Form</h1>

                                <div className="row my-3">
                                    <div className="col-6">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="formname" 
                                            placeholder="Enter Title"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            />
                                            <label for="formname">Enter Title</label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="formurl" 
                                            placeholder="Enter Url"
                                            value={formId}
                                            onChange={(e) => setFormId(e.target.value)}
                                            />
                                            <label for="formurl">Enter Url</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 my-2">
                                        <div className="form-floating form-section-col">
                                            <input 
                                            type="text" 
                                            className="form-control border-0" 
                                            id="about" 
                                            placeholder="Enter About"
                                            value={about}
                                            onChange={(e) => setAbout(e.target.value)}
                                            />
                                            <label for="about">Enter About</label>
                                        </div>
                                    </div>
                                </div>
                                

                                <div>
                                    <div className="row my-3">
                                
                                        <div className="col-lg-12 mb-1">
                                            <input 
                                                type="checkbox" 
                                                className="form-check-input" 
                                                id="isPublic" 
                                                checked={isPublic}
                                                onChange={(e) => setIsPublic(e.target.checked)}
                                            />

                                            <label className="form-check-label text-white" htmlFor="isPublic">
                                                {isPublic ? " 🔓 Public Form (Anyone can access)" : " 🔒 Private Form (Requires Keys)"}
                                            </label>
                                        </div>
                                        
                                        {!isPublic? 
                                            <>
                                            <p className='text-warning'>Viewkey for those to answer & Responsekey for you to see the answers!</p>
                                            <div className="col-lg-12 col-xl-6 my-1">
                                                <div className="form-floating form-section-col">
                                                    <input 
                                                    type="text" 
                                                    className="form-control border-0" 
                                                    id="formkey" 
                                                    placeholder="Enter View Key"
                                                    value={formKey}
                                                    onChange={(e) => setFormKey(e.target.value)}
                                                    />
                                                    <label for="formkey">View Key</label>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-xl-6 my-1">
                                                <div className="form-floating form-section-col">
                                                    <input 
                                                    type="text" 
                                                    className="form-control border-0" 
                                                    id="viewKey" 
                                                    placeholder="Enter Response Key"
                                                    value={viewKey}
                                                    onChange={(e) => setViewKey(e.target.value)}
                                                    />
                                                    <label for="viewKey">Response Key</label>
                                                </div>
                                            </div>
                                            </>
                                        
                                        : null}
                                        
                                    </div>
                                
                                    <div className="row g-4 my-3">
                                        <div className="col-6">
                                            <div className="form-section-col">
                                                {/* <button className="btn-primary w-100 py-3 px-5" onClick={addField}>Add Field</button> */}
                                                <input type="file" accept=".xlsx,.csv" required className="btn-warning w-100 py-3 px-5" onChange={handleFileChange} />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-section-col">
                                                <button className="btn-danger w-100 py-3 px-5" onClick={handleSubmitFile}>Save File</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.4s">
                            
                            <div className="form-section bg-success p-5 h-100">
                                <h1 className="display-4 text-white mb-4">Preview</h1>

                                <div>
                                    <div className="row g-4">

                                        {fields.map((field, idx) => (
                                            <div key={idx} className="col-lg-12 col-xl-6">
                                                <div className="form-floating form-section-col">
                                                    {renderField(field, idx)}
                                                    <label htmlFor={`field-${idx}`}>{field.label}</label>
                                                </div>
                                            </div>
                                        ))}

                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="h-100 overflow-hidden">
                                <iframe className="w-100" style={{height: '400px'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd" 
                                loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>


        <Footer/>
        </>
    );
}

export default FormBuilder;
